import React, { Fragment } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { LoadingSpinner, PlatformProducerOrderWithProductionPlanDetails } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';
import { GQLParty, GQLPlatformProducerOrderState } from '@jewelutions/core-crm-server-api-client-domain';
import { Button, Grid } from '@material-ui/core';
import { Check, StopCircle } from 'react-feather';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
}

const PlatformProducerOrderDetails: React.FC<IProps> = ({ party }: IProps) => {
  const { orderId } = ProducerNavigation.platformProducerOrderDetail.paramsFromPath(useRouteMatch());

  const {
    data: ordersData,
    loading: ordersLoading,
    refetch: ordersReload
  } = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrder(
    {
      platformProducerOrderId: orderId
    },
    { fetchPolicy: 'network-only' }
  );

  const {
    data: orderLineDetailsData,
    loading: orderLineDetailsLoading,
    refetch: orderLineDetailsReload
  } = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrderProductionPlanByPlatformProducerOrderId(
    {
      platformProducerOrderId: orderId
    },
    { fetchPolicy: 'network-only' }
  );

  const [changeOrderState, {}] = GQLOperationBuilder.deliveryUnit.updatePlatformProducerOrderState();

  const reloadData = () => {
    ordersReload();
    orderLineDetailsReload();
  };

  if (ordersLoading || orderLineDetailsLoading) return <LoadingSpinner />;

  const currentNextStateMappings: Map<GQLPlatformProducerOrderState, GQLPlatformProducerOrderState> = new Map(
    [
      [GQLPlatformProducerOrderState.New, GQLPlatformProducerOrderState.InProduction],
      [GQLPlatformProducerOrderState.InProduction, GQLPlatformProducerOrderState.Shipped],
      [GQLPlatformProducerOrderState.Shipped, GQLPlatformProducerOrderState.Completed]
    ]
  );
  const order = GQLOperationBuilder.deliveryUnit.platformProducerOrderFromResponse(ordersData);
  return (
    <Fragment>
      <Grid container direction="row">
        <Grid item md={4} style={{ marginBottom: '8px' }}>
          {currentNextStateMappings.has(order.state) && (
            <Button
              variant="contained"
              color="primary"
              style={{ width: '50%' }}
              onClick={() => {
                changeOrderState({
                  variables: { id: order.id, newState: currentNextStateMappings.get(order.state)!, note: '' }
                }).then(_result => {
                  reloadData();
                  successNotification(
                    toast,
                    `Order state changed succesfully to ${currentNextStateMappings.get(order.state)!}`,
                    () => {}
                  );
                });
              }}
            >
              <Check />
              <span style={{ marginLeft: '4px' }}>
                Promote to {currentNextStateMappings.get(order.state)!}
              </span>
            </Button>
          )}
        </Grid>
      </Grid>
      <PlatformProducerOrderWithProductionPlanDetails
        order={order}
        productionPlan={GQLOperationBuilder.deliveryUnit.platformProducerOrderProductionPlanFromResponse(
          orderLineDetailsData
        )}
      />

      {[GQLPlatformProducerOrderState.New, GQLPlatformProducerOrderState.InProduction].includes(
        order.state
      ) && (
        <Grid container direction="row">
          <Grid item md={4} style={{ marginBottom: '8px' }}>
            <Button
              variant="outlined"
              color="primary"
              style={{ width: '50%' }}
              onClick={() => {
                changeOrderState({
                  variables: { id: order.id, newState: GQLPlatformProducerOrderState.Rejected, note: '' }
                }).then(_result => {
                  reloadData();
                  successNotification(
                    toast,
                    `Order state changed succesfully to ${GQLPlatformProducerOrderState.Rejected}`,
                    () => {}
                  );
                });
              }}
            >
              <StopCircle />
              <span style={{ marginLeft: '4px' }}>Reject order</span>
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
};

export default PlatformProducerOrderDetails;
